import http from '@/environment/environment';
import { InviteGameDetail } from '@/_models/Game';
import store from '@/store/index';
import { Helper } from "@/utils/Helper";

export class InviteService
{
  async checkInvitation(gameId: string): Promise<boolean> {
    const userObj = store.getters['auth/user'];
    const jwtToken = store.getters['auth/jwtToken'];
    http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;

    try{
      const isInvitationValid = await http.get(`games/${gameId}/invites/${userObj.email}?userId=${userObj.userId}`);
      return isInvitationValid.data;
    }catch(error){
      Helper.endpointErrorHandling(error);
      return false;
    }
  }

  async fetchInvitation(): Promise<InviteGameDetail[]> {
    const userObj = store.getters['auth/user'];
    const jwtToken = store.getters['auth/jwtToken'];
    http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;

    try{
      const invitedGames = await http.get(`users/${userObj.userId}/invites`);
      return invitedGames.data;
    }catch(error){
      Helper.endpointErrorHandling(error);
      return [];
    }
  }
}